( function () {
	'use strict';

	function RequestCustomReportPageCtrl ( $q, $location, reportService, obsStatusFactory, Session, pdStatusFactory, apiService, logger ) {
		var self      = this;
		var preSelect = [ {
			'name' : 'New Report'
		}, {
			'name' : 'Select District'
		}, {
			'name' : 'Select Location'
		} ];

		function processResults ( results ) {
			obsStatusFactory.convertData();

			self.allDistricts  = obsStatusFactory.data.districts;
			self.allLocations  = obsStatusFactory.data.locations;
			self.locationsList = obsStatusFactory.data.locations;
			self.reports       = reportService.filterCustom( results[ 2 ] || [] );
			self.reports.unshift( preSelect[ 0 ] );
		}

		function mailErrorHandler () {
			logger.notifyError( 'The request has failed, please check your internet connection and try again.' );
		}

		function mailSuccessHandler () {
			$location.path( '/report/request-custom-report/submitted' );
		}

		function submitRequest () {
			var payload = {
				'reportId'          : self.selectedReport.id || '0',
				'reportName'        : self.selectedReport.name || '',
				'requestor'         : self.requesterName,
				'emailAddress'      : self.email,
				'phoneNumber'       : self.phone,
				'districtId'        : String( self.selectedDistrict.id ),
				'districtText'      : self.selectedDistrict.name,
				'locationId'        : String( self.selectedLocation.id ),
				'locationText'      : self.selectedLocation.name,
				'reportTitle'       : self.title,
				'reportDescription' : self.description,
				// TODO transfer to backend
				'supportAddress'    : 'support@edivate.com',
				'expedite'          : self.expedite
			};

			apiService.requestCustomReport
				.save( payload, mailSuccessHandler, mailErrorHandler );
		}

		function changeLocationFilter ( selected ) {
			// when using pdStatusFactory.filters.filterData, first parameter is an array type
			self.locationsList    = pdStatusFactory.filters.filterData( [ selected ], self.allLocations, 'districtId' );
			self.selectedLocation = preSelect[ 2 ];
		}

		function checkForm ( form ) {
			var disableButton = !form.$valid;

			if ( !self.selectedLocation.id ) {
				disableButton = true;
			}

			return disableButton;
		}

		function activate () {
			self.reports          = [ preSelect[ 0 ] ];
			self.selectedReport   = preSelect[ 0 ];
			self.selectedDistrict = preSelect[ 1 ];
			self.selectedLocation = preSelect[ 2 ];
			self.preview          = false;
			self.expedite         = false;
			self.requesterName    = Session.getCredentials().FirstName + ' ' + Session.getCredentials().LastName;

			$q.all( [
				obsStatusFactory.api.fetchHeirarchy().then( obsStatusFactory.processHeirarchy ),
				obsStatusFactory.api.fetchObsLocations().then( obsStatusFactory.processLocation ),
				reportService.getUserReports()
			] )
			.then( processResults );
		}

		activate();

		self.checkForm            = checkForm;
		self.submitRequest        = submitRequest;
		self.changeLocationFilter = changeLocationFilter;
	}

	RequestCustomReportPageCtrl.$inject = [ '$q', '$location', 'reportService', 'obsStatusFactory', 'Session', 'pdStatusFactory', 'apiService', 'logger' ];

	angular.module( 'app.report' )
		.controller( 'RequestCustomReportPageCtrl', RequestCustomReportPageCtrl );
} )( );
